<template>
    <div>
        <label class="radio-container" :class="{'overdue-warning':IsOverDue(service)}" v-for="(service,index) in petDueServices" v-bind:key="index">
            {{service.Title}} ({{service.DueDateDisplay}})
            <input type="checkbox" :checked="service.Selected" v-model="service.Selected">
            <span class="checkmark"></span>
        </label>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
    name: "PetDueServiceList",
    props: ['petDueServices'],
    methods: {
        IsOverDue(service) {
            var dueDateMoment = moment(service.DueDate);
            var nowMoment = moment();
            if(dueDateMoment.diff(nowMoment, "days")<0){
                return true;
            }
            return false;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/PetDueServiceList.vue